/**
 * Orchestra AI Platform - Output Node Component
 * 
 * Custom node component for workflow output results
 * 
 * @fileoverview Output node for workflow exit point
 */

import { Handle, Position } from 'reactflow';
import PropTypes from 'prop-types';

/**
 * @typedef {Object} OutputNodeData
 * @property {string} id
 * @property {string} label
 * @property {Object} output
 */

/**
 * Output Node Component
 * @param {Object} props
 * @param {OutputNodeData} props.data
 * @param {boolean} props.selected
 */
export function OutputNode({ data, selected }) {
  return (
    <div
      className={`output-node bg-orange-50 rounded-lg shadow-md border-2 p-3 min-w-[150px] ${
        selected ? 'border-orange-500' : 'border-orange-200'
      }`}
    >
      <Handle type="target" position={Position.Left} className="w-3 h-3" />

      <div className="node-header mb-2">
        <span className="px-2 py-1 text-xs font-semibold text-white bg-orange-500 rounded">
          Output
        </span>
      </div>

      <div className="node-body">
        <h3 className="font-semibold text-sm">{data.label || 'Workflow Output'}</h3>
        {data.output && Object.keys(data.output).length > 0 && (
          <div className="mt-2 text-xs text-gray-600">
            {Object.keys(data.output).length} output field(s)
          </div>
        )}
      </div>
    </div>
  );
}

OutputNode.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    output: PropTypes.object,
  }).isRequired,
  selected: PropTypes.bool,
};

